module.exports = __webpack_public_path__ + "img/m6.97fcfec9.png";